import React from 'react'
import CONSTANTS from 'utils/constants'

const CernerHIE = ({ residentId }: { residentId: string }) => {
  return (
    <iframe
      title="HIC"
      src={`${CONSTANTS.VITE_APP_CM_API}/services/cerner/${residentId}?init=true`}
      width="1080"
      height="900"
      style={{ border: 'none' }}
    />
  )
}

export default CernerHIE
